export default __webpack_public_path__ + "static/media/Ubuntu-Italic.fbb33104.ttf";